/* TS Ambassador Cards - infinite loop slider.
   Was an inline IIFE hardcoded to one section id. Now initialises every
   instance on the page and re-initialises on theme-editor section reload,
   which the inline version never did. */
const SELECTOR = '[data-ts-ac-slider]';

function initSlider(root) {
  const vp = root.querySelector('[data-ac-viewport]');
  const track = root.querySelector('[data-ac-track]');
  if (!vp || !track) return;

  const orig = Array.from(track.children);
  const n = orig.length;
  if (n < 2) return;

  // Clones are decorative duplicates - hide them from assistive tech.
  const deco = (c) => { c.setAttribute('aria-hidden', 'true'); c.setAttribute('role', 'presentation'); return c; };
  for (let i = 0; i < n; i++) track.appendChild(deco(orig[i].cloneNode(true)));
  for (let j = n - 1; j >= 0; j--) track.insertBefore(deco(orig[j].cloneNode(true)), track.firstChild);

  const prev = root.querySelector('[data-ac-prev]');
  const next = root.querySelector('[data-ac-next]');
  let idx = n;
  let animating = false;

  const readGap = () => {
    const cs = getComputedStyle(track);
    const g = parseFloat(cs.columnGap);
    if (!isNaN(g)) return g;
    const f = parseFloat(cs.gap);
    return isNaN(f) ? 24 : f;
  };
  /* One layout pass = measure() once, then write. Reading vp.clientWidth or
     getComputedStyle *after* a style write forces a synchronous relayout, so
     every writer below takes the already-measured values as a parameter
     instead of re-reading the DOM. */
  const measure = () => {
    const w = vp.clientWidth, g = readGap(), per = w >= 900 ? 3.5 : 1.18;
    return { vpW: w, gap: g, cardW: (w - g * Math.floor(per)) / per };
  };
  const setW = (m) => { Array.from(track.children).forEach((c) => { c.style.width = m.cardW + 'px'; }); };
  const positionArrows = (m) => { const top = (m.cardW * 0.75) / 2; [prev, next].forEach((b) => { if (b) b.style.top = top + 'px'; }); };
  const offset = (m) => -(idx * (m.cardW + m.gap)) + (m.vpW - m.cardW) / 2;
  const go = (instant, m) => {
    const mm = m || measure();
    track.style.transition = instant ? 'none' : 'transform .45s cubic-bezier(.4,0,.2,1)';
    track.style.transform = 'translateX(' + offset(mm) + 'px)';
    if (instant) track.getBoundingClientRect(); // force reflow so the next move animates
  };
  const move = (d) => { if (animating) return; animating = true; idx += d; go(false); };
  const layout = () => { const m = measure(); setW(m); positionArrows(m); go(true, m); };

  layout();

  window.addEventListener('resize', layout);
  track.addEventListener('transitionend', () => {
    animating = false;
    if (idx >= 2 * n) { idx -= n; go(true); }
    if (idx < n) { idx += n; go(true); }
  });
  if (prev) prev.addEventListener('click', () => move(-1));
  if (next) next.addEventListener('click', () => move(1));

  let sx = null;
  vp.addEventListener('touchstart', (e) => { sx = e.touches[0].clientX; }, { passive: true });
  vp.addEventListener('touchend', (e) => {
    if (sx === null) return;
    const dx = e.changedTouches[0].clientX - sx;
    if (Math.abs(dx) > 40) move(dx < 0 ? 1 : -1);
    sx = null;
  }, { passive: true });
}

function initAll(scope) {
  (scope || document).querySelectorAll(SELECTOR).forEach((root) => {
    if (root.dataset.acReady) return;
    root.dataset.acReady = '1';
    initSlider(root);
  });
}

initAll();
document.addEventListener('shopify:section:load', (e) => initAll(e.target));
